<template>
	<page-template>
		<template #content>
			<v-container fluid>
				<v-row class="d-flex align-center px-4 my-2" no-gutters>
					<v-col cols="auto">
						<v-btn text outlined @click="$router.go(-1)">
							<v-icon left>icon-angle-left</v-icon>{{ $t("stocks") }}
						</v-btn>
					</v-col>
				</v-row>

				<stock-details v-if="details" :details="details" @refresh="loadDetails" />
				<stock-images v-if="images" :stock-id="id" :images="images" />
				<batches v-if="details && batches" :stock-id="id" :meta="stockMeta" :batches="batches" @refresh="loadDetails" />
			</v-container>
		</template>
	</page-template>
</template>

<script>
import PageTemplate from "../../templates/PageTemplate.vue";
import StockDetails from "./StockDetails.vue";
import Batches from "./Batches.vue";
import StockImages from "./StockImages.vue";
import remote from "../../../data/remote";

export default {
	name: "Stock",
	components: { PageTemplate, StockDetails, Batches, StockImages },
	data() {
		return {
			id: this.$route.params.id,
			details: null,
			images: null,
			batches: null,
			stockMeta: null,
		};
	},
	computed: {
		$lang() {
			return this.$i18n.locale;
		},
	},
	methods: {
		loadDetails() {
			remote.stocks.detailView({
				id: this.id,
				lang: this.$i18n.locale,
				onSuccess: (doc) => {
					this.details = doc?.details ?? null;
					this.images = doc?.images ?? null;
					this.batches = doc?.batches ?? null;
					this.stockMeta = this.details
						? {
								companyId: this.details.companyId,
								unitCode: this.details.quantityUnit,
								formatId: this.details.formatId,
								measurementId: this.details.measurementId,
								formatMeta: this.details.formatMeta,
								measurementMeta: this.details.measurementMeta,
								autoComputedTotal: this.details.autoComputedTotal,
						  }
						: null;
				},
				onFail: () => this.$toast?.error(this.$t("failed_to_load_stock")),
			});
		},
	},
	created() {
		this.loadDetails();
	},
};
</script>
